// Get configuration from window.ENV (loaded from config.js) or process.env for local development
export const getConfig = (key: string): string => {
  return (window as any).ENV?.[key] || process.env[key] || '';
};

export const API_URL = getConfig('REACT_APP_API_URL') || 'http://localhost:7072';